export default __webpack_public_path__ + "static/media/mynovel-android.411a4d65.png";